import {tx, ptx, usePageText} from '../lib/page-text';
import { Link } from '../lib/localized-router';

const SDKS = [
  ['JavaScript / TypeScript', 'REST client, URL helpers, ES module and CommonJS package builds'],
  ['Swift', 'Native REST client and session helpers'],
  ['Kotlin', 'Native REST client and session helpers'],
  ['Java', 'REST service clients'],
  ['C# / .NET', 'REST client'],
  ['C++', 'REST client source'],
  ['Python', 'Server REST client'],
  ['Go', 'Server REST client'],
  ['Rust', 'REST client source'],
  ['Flutter / Dart', 'REST client source'],
  ['React Native', 'Hooks around the JavaScript REST client'],
  ['Unity', 'C# integration source'],
  ['Unreal', 'Plugin client source'],
  ['PHP', 'Server REST client'],
  ['Ruby', 'Server REST client'],
];

export function SdkPage() {
  usePageText();
  return <div>
    <h1 className="h1">{tx("SDKs & documentation")}</h1>
    <p className="subtitle">{tx("Start with the existing REST API. SDK source exists for the languages below; source availability does not mean a published package or a complete native media SDK.")}</p>
    <div className="flex gap" style={{ flexWrap: 'wrap', marginBottom: 20 }}><Link className="btn" to="/projects">{tx("Open Projects")}</Link><a className="btn outline" href="https://kardocloud.com/Live/Developer/" target="_blank" rel="noopener noreferrer">{tx("Developer documentation ↗")}</a></div>
    <div className="card" style={{ marginBottom: 16 }}>
      <h2>{tx("Server integration quick start")}</h2>
      <ol><li>{tx("Open Projects and select your project.")}</li><li>{tx("Create an API key with the stream read/write permissions your integration needs.")}</li><li>{tx("Store it in your server’s environment as KARDO_API_KEY. Run the commands below from that server.")}</li></ol>
      <p className="muted">{tx("Keep API keys and publishing keys private. Browser viewers should use the stream’s Share controls and scoped invitations. Creating a stream does not start broadcasting.")}</p>
      <pre className="code" style={{ fontSize: 12, maxWidth: '100%', overflowX: 'auto' }}>{`# Create an offline stream (requires streams:write)
curl --fail-with-body https://kardocloud.com/v1/me/streams \\
  -H "Authorization: Bearer $KARDO_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{"name":"My stream","mode":"BROADCAST"}'

# List your streams (requires streams:read)
curl --fail-with-body https://kardocloud.com/v1/me/streams \\
  -H "Authorization: Bearer $KARDO_API_KEY"`}</pre>
      <p className="muted">{tx("A permission error means the key, role or workspace access needs checking. Quota and validation errors must be resolved before retrying. A saved SDK option alone does not prove its corresponding media service is available.")}</p>
    </div>
    <div className="card" style={{ marginBottom: 16 }}>
      <h2>{tx("Build the JavaScript client from source")}</h2>
      <p>{tx("Use the repository version supplied for your integration. Build and pack it, then install the resulting archive in your server application.")}</p>
      <pre className="code" style={{ overflowX: 'auto' }}>{`cd Kardolive/packages/sdk-js
pnpm build
npm pack
# In your server application:
npm install /path/to/kardolive-sdk-0.1.0.tgz`}</pre>
      <p className="muted">{tx("The archive supports import and require with TypeScript declarations. Use recordingEnabled and chatEnabled with streams.create; rooms.create retains its recording and chat options. Native device capture and playback require a separate media integration.")}</p>
    </div>
    <h2>{tx("SDK source catalog")}</h2>
    <p className="muted">{tx("Public registry releases and native media support are not verified by this catalog. Confirm the exact version, installation instructions and supported operations before integrating. No drop-in scenario components are provided here.")}</p>
    <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 260px), 1fr))' }}>
      {SDKS.map(([name, scope]) => <article className="card" key={name}><h3 style={{ marginTop: 0 }}>{name}</h3><span className="badge">{tx("Source implementation")}</span><p className="muted">{scope}</p></article>)}
    </div>
  </div>;
}
